import request from '@/utils/request'

export function list(query) {
    return request({
        url: '/course/list',
        method: 'get',
        params: query
    })
}

export function info(id) {
    return request({
        url: '/course/info/' + id,
        method: 'get'
    })
}

export function save(data) {
    return request({
        url: '/course/save',
        method: 'post',
        data
    })
}

export function update(data) {
    return request({
        url: '/course/update',
        method: 'post',
        data
    })
}

export function remove(data) {
    return request({
        url: '/course/delete',
        method: 'post',
        data
    })
}

export function sum(courseId) {
    let data = {courseId}
    return request({
        url: '/course/sum',
        method: 'post',
        data
    })
}

